<!-- this is an example -->
<template lang="pug">
.row
   .col-3
     .mb-2
       button.btn.btn-primary(@click="collapseAll") collapse all
       button.btn.btn-primary.ml-1(@click="expandAll") expand all
     Tree(:data="tree1data" draggable cross-tree)
         div(slot-scope="{data, store}")
           template(v-if="!data.isDragPlaceHolder")
             b(v-if="data.children && data.children.length" @click="store.toggleOpen(data)") {{data.open ? '-' : '+'}}&nbsp;
             span {{data.text}}
   .col-3
     Tree.tree4(:data="tree4data" draggable cross-tree :indent="30" :space="0")
       div(slot-scope="{data, store}")
         template(v-if="!data.isDragPlaceHolder")
           b(v-if="data.children && data.children.length" @click="store.toggleOpen(data)") {{data.open ? '-' : '+'}}&nbsp;
           span {{data.text}}
   .col-3
     Tree(:data="tree2data" draggable cross-tree)
       div(slot-scope="{data, store}")
         template(v-if="!data.isDragPlaceHolder")
           b(v-if="data.children && data.children.length" @click="store.toggleOpen(data)") {{data.open ? '-' : '+'}}&nbsp;
           span {{data.text}}
     .mt-2
       button.btn.btn-primary(@click="addChild") Add child
   .col-3
     Tree.tree3(:data="tree3data" draggable cross-tree)
       div(slot-scope="{data, store}")
         template(v-if="!data.isDragPlaceHolder")
           b(v-if="data.children && data.children.length" @click="store.toggleOpen(data)") {{data.open ? '-' : '+'}}&nbsp;
           span {{data.text}}


</template>

<script>
import {DraggableTree, Tree} from 'vue-draggable-nested-tree'
import * as th from 'tree-helper'
import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'rake_tree',
  components: {Tree: DraggableTree},
  data () {
    return {
    tree1data: [
        {text: 'node 1'},
        {text: 'node 2'},
        {text: 'node 3 undraggable', draggable: false},
        {text: 'node 4'},
        {text: 'node 4 undroppable', droppable: false},
        {text: 'node 5', children: [
          {text: 'node 1'},
          {text: 'node 2', children: [
            {text: 'node 3'},
            {text: 'node 4'},
          ]},
          {text: 'node 2 undroppable', droppable: false, children: [
            {text: 'node 3'},
            {text: 'node 4'},
          ]},
          {text: 'node 2', children: [
            {text: 'node 3'},
            {text: 'node 4 undroppable', droppable: false},
          ]},
          {text: 'node 3'},
          {text: 'node 4'},
          {text: 'node 3'},
          {text: 'node 4'},
          {text: 'node 3'},
          {text: 'node 4'},
          {text: 'node 3'},
          {text: 'node 4'},
        ]},
      ],
      tree2data: [
      ],
      tree3data: [
          {text: 'node 1'},
          {text: 'node 2'},
          {text: 'node 3 undraggable', draggable: false},
          {text: 'node 4'},
          {text: 'node 4 undroppable', droppable: false},
          {text: 'node 5', children: [
            {text: 'node 1'},
            {text: 'node 2', children: [
              {text: 'node 3'},
              {text: 'node 4'},
            ]},
            {text: 'node 2 undroppable', droppable: false, children: [
              {text: 'node 3'},
              {text: 'node 4'},
            ]},
            {text: 'node 2', children: [
              {text: 'node 3'},
              {text: 'node 4 undroppable', droppable: false},
            ]},
            {text: 'node 3'},
            {text: 'node 4'},
            {text: 'node 3'},
            {text: 'node 4'},
            {text: 'node 3'},
            {text: 'node 4'},
            {text: 'node 3'},
            {text: 'node 4'},
          ]},
        ],
      tree4data: [
          {text: 'node 1'},
          {text: 'node 2'},
          {text: 'node 3 undraggable', draggable: false},
          {text: 'node 4'},
          {text: 'node 4 undroppable', droppable: false},
          {text: 'node 5', children: [
            {text: 'node 1'},
            {text: 'node 2', children: [
              {text: 'node 3'},
              {text: 'node 4'},
            ]},
            {text: 'node 2 undroppable', droppable: false, children: [
              {text: 'node 3'},
              {text: 'node 4'},
            ]},
            {text: 'node 2', children: [
              {text: 'node 3'},
              {text: 'node 4 undroppable', droppable: false},
            ]},
            {text: 'node 3'},
            {text: 'node 4'},
            {text: 'node 3'},
            {text: 'node 4'},
            {text: 'node 3'},
            {text: 'node 4'},
            {text: 'node 3'},
            {text: 'node 4'},
          ]},
        ],
      }
  },
  created() {
    this.getDevices()
    this.getRakelink()
  },
  methods: {
    getRakelink() {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/rakelink`)
      .then(response => {
        var that = this
        that.tree4data = []
        _.forEach(_.groupBy(response.data, 'first_train_no'), function(value, key) {
          var children = []
          _.map(value, function(v) {
            children.push(
              {
                text: v.train_no + ' ' + v.dep + ' ' + v.org + '-->' + v.dest + ' ' + v.arr,
                draggable: true,
                droppable: false
              }
            )
          })

         that.tree4data.push(
           {
             text: key + '',
             children : children,
             droppable: true,
             draggable: false
           }
         )
       });
       console.log(that.tree1data)
      })
      .catch(e => {
        console.log(e)
      })
    },
    getDevices() {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/device`)
        .then(response => {
          var that = this
          that.tree1data = []
          _.forEach(response.data, function(value, key) {

           that.tree1data.push(
             {
               text: value.name ,
               children : [],
             }
           )
         });
        })
        .catch(e => {
          if (e.status === 401) {
            console.log(e)
            this.$router.push({
              name: 'Login'
            })
          }
        })
    },
    // add child to tree2
    addChild() {
      this.tree2data[0].children.push({text: 'child'})
    },
    expandAll() {
      th.breadthFirstSearch(this.tree1data, node => {
        node.open = true
      })
    },
    collapseAll() {
      th.breadthFirstSearch(this.tree1data, node => {
        node.open = false
      })
    },
  },
  // created() {},
  // mounted() {},
}
</script>

<style>
.he-tree{
  border: 1px solid #ccc;
  padding: 10px;
  overflow-y: scroll;
  max-height: 75vh;

}
.tree-node{
}
.tree-node-inner{
  padding: 1px;
  border: 1px solid #ccc;
  cursor: pointer;
  font-size: 10px;
}
.draggable-placeholder{
}
.draggable-placeholder-inner{
  border: 1px dashed #0088F8;
  box-sizing: border-box;
  background: rgba(0, 136, 249, 0.09);
  color: #0088f9;
  text-align: center;
  padding: 0;
  display: flex;
  align-items: center;
}
.tree3{
  .tree-node-inner{
    border: none;
    padding: 0px;
  }
  .tree-node-inner-back:hover{
    background: #ddd;
  }
}

.tree4{
  .tree-node-inner{
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 2px 10px;
    backgroud: #ccc;
  }
  .draggable-placeholder-inner{
    background-color: orangered;
  }
}
</style>
